namespace GeniuzPOS.ReportMasterData {
    export namespace Report_1201_RecvService {
        export const baseUrl = 'ReportMasterData/Report_1201_Recv';

        export declare function Create(request: Serenity.SaveRequest<Report_1201_RecvRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<Report_1201_RecvRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<Report_1201_RecvRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<Report_1201_RecvRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ReportMasterData/Report_1201_Recv/Create",
            Update = "ReportMasterData/Report_1201_Recv/Update",
            Delete = "ReportMasterData/Report_1201_Recv/Delete",
            Retrieve = "ReportMasterData/Report_1201_Recv/Retrieve",
            List = "ReportMasterData/Report_1201_Recv/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>Report_1201_RecvService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
